import { instrumentalAlbums } from "@/data/albums";

export const Marquee = () => {
  const items = instrumentalAlbums.map((a) => a.title.replace(" — MEMORIES OF TOMORROW", ""));
  const row = [...items, ...items];
  return (
    <div data-testid="editorial-marquee" className="marquee-wrap relative overflow-hidden border-y border-white/10 py-10 bg-[#070707]">
      <div className="marquee-track">
        {row.map((t, i) => (
          <span key={i} className="font-serif italic text-[#8a8a8a] text-5xl md:text-7xl px-10 md:px-16 tracking-tight">
            {t} <span className="not-italic text-[#2a2a2a] mx-6">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
};
